export const LANDING_PAGES_META_CONTENTS = Object.freeze({
  ['default']: {
    title: 'Fast and Reliable Shipping and Storage Services Globally',
    description:
      'Fast, reliable shipping and storage solutions globally. Affordable, secure, and customized services for all your shipping and storage needs in any location.',
    keywords:
      'shipping and mailing services, moving and storage companies near me, moving and storage companies nyc, shipping and stuff, ship and store'
  },
  ['shipping_and_storage_services']: {
    title: 'Fast and Reliable Shipping and Storage Services Globally',
    description:
      'Fast, reliable shipping and storage solutions globally. Affordable, secure, and customized services for all your shipping and storage needs in any location.',
    keywords:
      'shipping and mailing services, moving and storage companies near me, moving and storage companies nyc, shipping and stuff, ship and store'
  },

  ['ship_to_storage']: {
    title: 'Convenient Ship To Storage Solutions For Your Needs',
    description:
      'Get secure, fast ship-to-storage services that meet your needs. Reliable solutions for storing and shipping your belongings affordably and efficiently.',
    keywords:
      'shipping storage boxes, ship to storage facility, ship to a storage unit, ship to a storage facility​, shipping to storage unit​'
  },

  ['ship_to_self_storage']: {
    title: 'Ship To Self Storage Services Fast And Affordable',
    description:
      'Ship to self storage services available now. Fast, secure, and affordable options for shipping your items to a self-storage facility.',
    keywords:
      'ship to self-storage, self-storage shipping, self-storage solutions, store and ship, affordable self-storage'
  },

  ['ship_to_school']: {
    title: 'Ship to School with Fast and Secure Services',
    description:
      'Ship to school quickly and affordably. We offer reliable shipping services that ensure your items are delivered securely and on time for school.',
    keywords: 'ship to school, student shipping services, college shipping, ship to dorm, school storage solutions'
  },

  ['college_storage_solutions']: {
    title: 'College Storage Solutions Secure And Reliable',
    description:
      'College storage solutions for students. Fast, secure, and reliable options for storing college items safely during the academic year.',
    keywords:
      'college storage, student storage services, dorm room storage, affordable college storage, summer storage for students'
  },

  ['ship_to_college_dorm']: {
    title: 'Quick and Reliable Ship To College Dorm Solutions',
    description:
      'Quick and secure ship-to-college dorm services. Affordable, fast, and reliable solutions to deliver your belongings safely to your dorm room.',
    keywords: 'ship to dorm, dorm room movers, college student shipping, college dorm storage, move to dorm'
  },

  ['ship_and_storage_near_me']: {
    title: 'Find Affordable Ship and Storage Services Near You',
    description:
      'Find fast, reliable ship-and-storage services near you. Affordable, secure storage and shipping solutions tailored to meet your needs with ease.',
    keywords:
      'ship and pack near me, shipping supply store near me, storage near by, ship and mail near me, shipping warehouse near me, ship and go near me'
  },

  ['storage_unit_with_shipping']: {
    title: 'Secure Storage Unit with Shipping Services',
    description:
      'Secure, reliable storage unit with shipping services. Get fast, affordable solutions for storing and shipping your items safely and conveniently.',
    keywords:
      'storage unit with shipping, store and ship, shipping and storage services, ship to storage unit, storage shipping solutions'
  },

  ['ship_to_storage_facility']: {
    title: 'Ship to Storage Facility Solutions for Convenience',
    description:
      'Fast, secure ship-to-storage facility services tailored to your needs. Affordable, reliable solutions for your shipping and storage requirements.',
    keywords:
      'ship to storage facility, shipping to storage, shipping facility, ship storage space, ship to a storage unit'
  },

  ['storage_facilities_that_ship']: {
    title: 'Storage Facilities That Ship Quickly and Securely',
    description:
      'Get reliable storage facilities that offer shipping. Fast, affordable, and secure solutions for shipping and storing your belongings with ease.',
    keywords:
      'storage facilities that ship, shipping storage services, storage with shipping, storage and shipping solutions'
  },

  ['storage_and_shipping_near_me']: {
    title: 'Find Reliable Storage and Shipping Services Near You',
    description:
      'Find fast, secure storage and shipping services near you. Affordable and reliable solutions for storing and shipping your belongings efficiently.',
    keywords:
      'storage and shipping near me, local shipping and storage, near me storage facilities, storage solutions near me'
  },

  ['self_storage_services']: {
    title: 'Secure and Affordable Self Storage Services Near You',
    description:
      'Secure, affordable self-storage services near you. Get fast and reliable solutions for storing and protecting your belongings for any period.',
    keywords:
      'self-storage services, personal storage, affordable self-storage, storage units near me, self-storage solutions'
  },

  ['storage_and_shipping_services']: {
    title: 'Comprehensive Storage and Shipping Services for All',
    description:
      'Comprehensive storage and shipping services for all your needs. Affordable, secure, and fast solutions that ensure your items are stored and shipped safely.',
    keywords:
      'storage and shipping services, shipping storage solutions, store and shipshipping box storage,, storage box shipping	, shipping and storage	, packing and storage boxes,, packing storage boxes'
  },

  ['u_box_container_storage']: {
    title: 'Reliable U-Box Container Storage Services for Students',
    description:
      'Reliable U-Box container storage services designed for students. Fast, affordable solutions for storing and shipping your belongings securely.',
    keywords: 'U-Box container storage, container storage services,u storage boxes,  ubox rentals, u box storage'
  },

  ['dorm_moving_storage']: {
    title: 'Fast and Affordable Dorm Moving Storage Solutions',
    description:
      'Fast and affordable dorm moving storage solutions. Reliable, secure services to store and move your belongings quickly and affordably.',
    keywords: 'dorm moving services, dorm room movers, college moving storage, student moving and storage solutions'
  },

  ['college_boxes_storage']: {
    title: 'College Boxes Storage Services for Students Fast',
    description:
      'College boxes storage services fast and secure. Affordable, reliable storage solutions for storing and shipping your college belongings.',
    keywords:
      'college storage, student boxes storage, ship to storage, affordable college storage, student storage solutions'
  },

  ['college_dorm_moving']: {
    title: 'Secure College Dorm Moving Services for Students',
    description:
      'Fast and secure college dorm moving services for students. Affordable solutions to move your belongings quickly and safely to your dorm.',
    keywords: 'college dorm movers, dorm moving storage, student moving services, dorm storage solutions, ship to dorm'
  },

  ['college_moving_services']: {
    title: 'Affordable and Fast College Moving Services Available',
    description:
      'Affordable college moving services available. Fast, reliable, and secure solutions to help students move their belongings with ease.',
    keywords:
      'college moving services, student moving storage, dorm room movers, college moving solutions, affordable student moving'
  },

  ['college_storage_solution']: {
    title: 'Reliable College Storage Solutions for Students',
    description:
      'Reliable college storage solutions for students. Secure, affordable services for storing your items during and after the school year.',
    keywords:
      'college storage solutions, student storage services, dorm room storage, affordable college storage, summer storage for students'
  },

  ['college_moving_company']: {
    title: 'College Moving Company with Affordable Services',
    description:
      'Affordable college moving company with reliable services. Fast, secure, and convenient solutions for moving your belongings safely.',
    keywords:
      'college moving company, student movers, dorm room moving services, affordable moving solutions, student storage solutions'
  },

  ['college_student_storage_moving_services']: {
    title: 'College Student Storage Moving Services Secure',
    description:
      'College student storage and moving services available. Fast, affordable, and secure solutions for storing and moving your college items.',
    keywords:
      'Student Storage Solutions, College Moving Services, Dorm Room Storage, Summer Storage for Students, Student Moving Companies, University Storage Options, Affordable College Moving, Campus Moving and Storage'
  },

  ['college_shipping_storage_moving_services']: {
    title: 'College Shipping Storage and Moving Services Available',
    description:
      'College shipping, storage, and moving services all in one. Fast, reliable solutions to store, move, and ship your belongings securely.',
    keywords:
      'college storage moving services, student moving and storage, ship and store services, college moving company'
  },

  ['college_moving_student_storage_and_shipping']: {
    title: 'College Moving, Storage, and Shipping Services Combined',
    description:
      'College moving, storage, and shipping services combined. Secure and affordable solutions for all your student moving and storage needs.',
    keywords:
      'dorm room movers, student moving services, college storage solutions, affordable dorm room storage, ship and store'
  },

  ['dorm_room_movers_college_moving_storage']: {
    title: 'Dorm Room Movers for College Moving and Storage',
    description:
      'Dorm room movers for college students. Fast, affordable, and reliable services for moving and storing your dorm room belongings securely.',
    keywords: 'dorm room movers boxes, affordable college storage,  student storage solutions'
  },

  ['college_storage_price']: {
    title: 'Affordable College Storage Prices for Students',
    description:
      'Affordable college storage prices for students. Fast, secure storage solutions to store your belongings safely during the school year.',
    keywords:
      'free student storage, affordable student storage, free college storage, dorm room storage, student storage solutions'
  },

  ['free_student_storage_services']: {
    title: 'Free and Convenient Student Storage Services',
    description:
      'Free student storage services available. Secure, convenient, and affordable solutions for students needing storage for their belongings.',
    keywords:
      'college student movers, dorm room moving, student storage and moving, college moving services, affordable moving services'
  },

  ['collage_student_moving']: {
    title: 'Reliable College Student Moving Services',
    description:
      'Reliable college student moving services. Fast, secure, and affordable solutions to move your belongings to and from your college campus.',
    keywords:
      'college student shipping, student movers, ship to dorm, college shipping solutions, student shipping services'
  },

  ['collage_student_shipping']: {
    title: 'Fast and Secure College Student Shipping Services Available',
    description:
      'Fast and secure college student shipping services. Affordable, reliable solutions for safely shipping your belongings to your school or dorm.',
    keywords:
      'student storage solutions, student dorm storage, affordable college storage, summer storage for students, dorm room storage'
  },

  ['college_student_storage']: {
    title: 'Reliable College Student Storage Services For All Needs',
    description:
      'Reliable college student storage services for all your needs. Affordable, secure storage solutions for students during the school year.',
    keywords:
      'free self-storage units, affordable self-storage, self-storage deals, free storage near me, self-storage services'
  },

  ['free_self_storage_units']: {
    title: 'Free Self Storage Units Available Now for Students',
    description:
      'Free self-storage units available now for students. Safe, secure, and convenient storage solutions for your personal belongings.',
    keywords:
      'free public storage, affordable self-storage, public storage services, free storage units, public self-storage near me'
  },

  ['free_public_self_storage']: {
    title: 'Free Community Storage Solutions',
    description:
      'Get secure, no-cost storage space with flexible timelines and easy access. Store your items safely during moves, travel, or transitions with ShipAndStorage.',
    keywords:
      'free storage places, affordable storage options, free storage units, free public storage, storage near me'
  },

  ['free_storage_places']: {
    title: 'Locate Free Storage Places Near You for Convenience',
    description:
      'Locate free storage places near you. Safe, secure, and convenient solutions for storing your belongings without any cost.',
    keywords:
      'summer storage, student summer storage, seasonal storage solutions, affordable summer storage, summer storage for students'
  },

  ['storage_for_summer']: {
    title: 'Affordable Storage for Summer Students and Travelers',
    description:
      'Affordable storage options for summer travelers and students. Fast and secure solutions to store your belongings during the summer.',
    keywords:
      'storage scholars services, student storage solutions, summer storage for students, college storage solutions'
  },

  ['storage_scholars_services']: {
    title: 'Storage Scholars Services for Secure Storage Solutions',
    description:
      'Storage Scholars services for secure storage. Fast, reliable, and affordable solutions to store your items safely.',
    keywords:
      'student moving and storage, dorm room storage, student movers, affordable student storage, college moving services'
  },

  ['storage_moving_and_student_storage']: {
    title: 'Moving and Storage Solutions for Students Secure',
    description:
      'Reliable moving and student storage solutions. Affordable, secure services to store and move your belongings safely and easily.',
    keywords:
      'affordable storage, cheap storage near me, budget-friendly storage, low-cost storage solutions, cheap self-storage'
  },

  ['cheap_storage_places']: {
    title: 'Cheap Storage Places Available Near You for Convenience',
    description:
      'Find cheap storage places near you. Safe, secure, and affordable storage options for all your belongings at convenient locations.',
    keywords:
      'cheap storage places, affordable storage units, budget-friendly storage, low-cost storage facilities, storage rental deals,'
  },

  ['storage_for_winter']: {
    title: 'Reliable Storage for Winter Students and Travelers',
    description:
      'Reliable storage solutions for winter travelers and students. Affordable and secure options for storing your items during winter.',
    keywords:
      'winter storage, seasonal storage, winter storage solutions, store items for winter, snow gear storage, winter sports equipment storage'
  },

  ['storage_near_me']: {
    title: 'Find Affordable Storage Solutions Near You Today',
    description:
      'Find affordable storage solutions near you today. Safe and secure storage services to protect your belongings at a great price.',
    keywords:
      'storage near me, local storage units, nearby storage solutions, closest storage facility, find storage near me, nearby self-storage'
  },

  ['self_storage_near_me']: {
    title: 'Secure and Convenient Self Storage Services Near You',
    description:
      'Secure and convenient self-storage services near you. Fast, reliable, and affordable solutions for storing your items safely.',
    keywords:
      'self-storage near me, find self-storage, nearby storage units, affordable self-storage, local self-storage, cheap self-storage options'
  },

  ['storage_spaces_for_rent']: {
    title: 'Affordable Storage Spaces For Rent at Great Prices',
    description:
      'Affordable storage spaces for rent at great prices. Safe, secure, and convenient options for storing your belongings.',
    keywords:
      'storage spaces for rent, rent a storage unit, affordable storage rental, rental storage options, temporary storage rental, long-term storage rental'
  },

  ['storage_pricing_calculator']: {
    title: 'Storage Pricing Calculator to Estimate Your Costs',
    description:
      'Use our storage pricing calculator to estimate your storage costs. Fast and accurate pricing solutions for all your storage needs.',
    keywords:
      'storage pricing calculator, estimate storage cost, storage unit pricing, calculate storage fees, self-storage cost estimate, storage rental pricing'
  },

  ['storage_cost_estimate']: {
    title: 'Get a Storage Cost Estimate Fast and Easy',
    description:
      'Get a fast and easy storage cost estimate. Affordable, accurate solutions to estimate the cost of storing your belongings.',
    keywords:
      'storage cost estimate, self-storage cost, how much does storage cost, estimate storage fees, affordable storage options, storage price estimate'
  },

  ['home_storage_services']: {
    title: 'Home Storage Services Affordable and Secure for All',
    description:
      'Affordable and secure home storage services available. Safe, convenient solutions for storing your personal belongings with ease and reliability.',
    keywords:
      'home storage solutions, self storage companies near me, home storage center, home storage unit, self storage services'
  },

  ['storage_unit_cost']: {
    title: 'Get an Accurate Estimate of Your Storage Unit Cost',
    description:
      'Get an accurate estimate of your storage unit cost. Affordable, reliable solutions for renting a storage unit tailored to your specific needs.',
    keywords:
      'storage unit cost, how much is a storage unit, self-storage prices, storage unit pricing, affordable storage unit costs, storage unit fees'
  },

  ['storage_and_shipping_boxes']: {
    title: 'Find Storage and Shipping Boxes for Any Need',
    description:
      'Find storage and shipping boxes for any need. Affordable, durable solutions for shipping and storing your personal or business belongings.',
    keywords:
      'storage and shipping boxes, ship storage boxes, moving boxes and storage, affordable shipping boxes, packing boxes for storage, shipping and storage solutions'
  },

  ['self_storage_and_shipping_solution']: {
    title: 'Self Storage And Shipping Solutions Fast And Secure',
    description:
      'Self-storage and shipping solutions available. Fast, affordable, and secure options for storing and shipping your personal belongings.',
    keywords:
      'self-storage and shipping, storage and shipping solutions, self-storage and shipping services, storage and shipping combo, affordable storage and shipping'
  },

  ['long_term_storage_solutions']: {
    title: 'Long-Term Storage Solutions for Personal and Business',
    description:
      'Long-term storage solutions available for personal and business use. Affordable, secure services for storing your items safely over time.',
    keywords:
      'long term self storage near me, long term self storage	, long term household storage, long and short term storage'
  },

  ['short_term_storage_services']: {
    title: 'Short-Term Storage Services for Your Temporary Needs',
    description:
      'Short-term storage services available for your temporary needs. Affordable, fast, and secure solutions to store your belongings for a short period.',
    keywords:
      'short-term storage services, temporary storage solutions, short-term self-storage, affordable short-term storage, local short-term storage, quick storage rental, short term storage solutions,  short term storage space, short term storage options'
  },

  ['business_storage_services']: {
    title: 'Affordable Business Storage Services for Secure Storage',
    description:
      'Affordable business storage services available. Secure solutions for storing your business items and equipment safely and conveniently.',
    keywords:
      'business storage services, storage for businesses, commercial storage solutions, affordable business storage, office storage services, corporate storage options'
  },

  ['personal_storage_options']: {
    title: 'Personal Storage Options Tailored for Your Needs',
    description:
      'Personal storage options tailored for your needs. Affordable, secure, and convenient solutions for storing your personal belongings.',
    keywords:
      'personal storage options, personal self-storage, private storage solutions, personal storage rental, affordable storage for individuals, personal belongings storage'
  },

  ['document_storage_solutions']: {
    title: 'Secure Document Storage Solutions for Business and Personal',
    description:
      'Secure document storage solutions available for business and personal use. Safe, reliable options for storing important documents securely.',
    keywords:
      'document storage solutions, store important documents, secure document storage, document archiving services, affordable document storage, long-term document storage'
  },

  ['self_storage_facilities_near_me']: {
    title: 'Find Self Storage Facilities Near Me for Convenience',
    description:
      'Find self storage facilities near me for convenience. Secure, affordable options for storing your belongings safely and easily near your location.',
    keywords:
      'self-storage facilities near me, find local self-storage, nearby storage units, affordable self-storage near me, cheap storage facilities, self-storage locations'
  },

  ['fedex_shipping_and_storage_solutions']: {
    title: 'FedEx Shipping and Storage Solutions Secure and Fast',
    description:
      'FedEx shipping and storage solutions available. Fast, secure, and affordable services for shipping and storing your personal belongings.',
    keywords:
      'FedEx shipping and storage, FedEx storage services, ship and store with FedEx, fedex ship and hold, fedex shipping and printing near me, fedex ship to store'
  },

  ['dhl_shipping_and_storage_services']: {
    title: 'Reliable DHL Shipping and Storage Services Available',
    description:
      'Reliable DHL shipping and storage services. Secure and affordable options for shipping and storing your personal and business items.',
    keywords:
      'DHL shipping and storage, DHL storage services, ship and store with DHL, affordable DHL shipping, DHL storage solutions, DHL storage locations'
  },

  ['ups_storage_and_shipping_solutions']: {
    title: 'UPS Storage and Shipping Solutions for Fast Service',
    description:
      'UPS storage and shipping solutions available. Fast, reliable services for storing and shipping your belongings with ease and convenience.',
    keywords:
      'UPS shipping and storage, UPS storage solutions, ship and store with UPS, ups shipping and drop off location, ups shipping and packing'
  },

  ['shipping_and_storage_services_near_me']: {
    title: 'Affordable Shipping And Storage Services Near Me',
    description:
      'Affordable shipping and storage services near me. Fast, secure, and reliable solutions for storing and shipping your personal or business belongings.',
    keywords:
      'shipping and storage near me, ship and store near me, local storage and shipping, affordable storage and shipping, nearby shipping and storage, find storage and shipping'
  },

  ['self_storage_solution']: {
    title: 'Reliable Self Storage Solutions For Your Needs',
    description:
      'Reliable self-storage solutions for your needs. Fast, affordable, and secure options for storing your personal or business items.',
    keywords:
      'self-storage solution, personal storage solution, affordable self-storage servicesstorage self near me, self storage solutions, store that self storage'
  },

  ['moving_and_storage_discounts']: {
    title: 'Get Moving And Storage Discounts For Relocations',
    description:
      'Get moving and storage discounts for your relocation. Affordable, secure, and fast services to store and move your belongings safely.',
    keywords:
      'moving and storage discounts, affordable moving storage, moving storage deals, discount moving and storage services, cheap moving and storage, storage for moving'
  },

  ['international_shipping_and_storage_services']: {
    title: 'International Shipping And Storage Services Available',
    description:
      'International shipping and storage services available. Secure, fast, and affordable solutions for storing and shipping your items globally.',
    keywords:
      'international shipping and storage, ship and store internationally, global shipping and storage, international storage solutions, affordable international shipping'
  },

  ['luggage_shipping_and_storage_services']: {
    title: 'Fast Luggage Shipping And Storage Services Near You',
    description:
      'Fast luggage shipping and storage services near you. Affordable, secure options for safely storing and shipping your luggage.',
    keywords:
      'luggage shipping and storage, store and ship luggage, international luggage shipping, affordable luggage storage, luggage delivery and storage, long-term luggage storage'
  },

  ['residential_and_commercial_storage']: {
    title: 'Residential And Commercial Storage Services Secure',
    description:
      'Residential and commercial storage services available. Secure and fast options for storing and managing your business or personal items.',
    keywords:
      'residential and commercial storage, store residential items, commercial storage solutions, business and home storage, affordable storage for homes and businesses'
  },

  ['dorm_room_movers_and_storage']: {
    title: 'Dorm Room Movers And Storage Solutions For Students',
    description:
      'Dorm room movers and storage services for students. Affordable, secure, and reliable options for moving and storing dorm room belongings.',
    keywords:
      'dorm room movers and storage, student storage services, college storage solutions, affordable dorm room storage, student moving and storage, campus storage services'
  },

  ['affordable_self_storage_services']: {
    title: 'Affordable Self-Storage Services Near You',
    description:
      'Affordable self-storage services near you. Secure, fast, and reliable options for storing your personal items safely and easily.',
    keywords:
      'affordable self-storage services, cheap self-storage, budget-friendly storage units, discount storage services, low-cost self-storage, storage deals'
  },

  ['office_moving_and_storage']: {
    title: 'Office Moving And Storage Solutions Secure and Fast',
    description:
      'Office moving and storage services available now. Fast, secure, and reliable options for storing and moving your office equipment and documents.',
    keywords:
      'office moving and storage, store office equipment, office relocation storage, affordable office storage solutions, commercial moving and storage, office storage rental'
  },

  ['office_document_storage_solutions']: {
    title: 'Secure Office Document Storage Solutions Available',
    description:
      'Secure office document storage solutions available now. Affordable and reliable options for securely storing your office documents.',
    keywords:
      'office document storage, store office records, secure office storage, affordable document storage, long-term office storage, document archiving for businesses'
  },

  ['document_storage_services']: {
    title: 'Document Storage Services for Businesses and Individuals',
    description:
      'Document storage services for businesses and individuals. Secure, fast, and affordable solutions for storing important documents.',
    keywords:
      'document storage services, secure document storage, document archiving services, affordable document storage, long-term document storage, professional document storage'
  },

  ['legal_document_storage_for_law_firms']: {
    title: 'Legal Document Storage Solutions for Law Firms',
    description:
      'Legal document storage solutions for law firms. Secure, reliable, and affordable services for storing important legal documents.',
    keywords:
      'legal document storage, store legal files, law firm document storage, secure legal document storage, legal records archiving, affordable legal document storage'
  },

  ['college_luggage_storage_solutions']: {
    title: 'College Luggage Storage Solutions Fast and Affordable',
    description:
      'College luggage storage solutions fast and affordable. Secure and reliable services for storing and managing your college luggage.',
    keywords:
      'college luggage storage, store college luggage, student luggage storage solutions, affordable college storage, luggage storage for students, college storage services'
  },

  ['student_storage_&_shipping_services']: {
    title: 'Student Storage and Shipping Services for Convenience',
    description:
      'Student storage and shipping services available now. Affordable, fast, and secure solutions for storing and shipping student belongings.',
    keywords:
      'student storage and shipping, ship and store student belongings, college storage and shipping, affordable student storage, student moving services, college shipping'
  },

  ['student_storage_and_shipping_services']: {
    title: 'Student Storage And Shipping Services Affordable',
    description:
      'Affordable student storage and shipping services available now. Secure, fast, and convenient solutions for storing and shipping belongings.',
    keywords:
      'student storage and shipping, college storage solutions, ship and store student items, student storage services, affordable student shipping, campus storage services'
  },

  ['schools_summer_storage']: {
    title: 'Schools Summer Storage Services Fast And Affordable',
    description:
      'Schools summer storage services available now. Fast, secure, and affordable options for storing your school items during the summer break.',
    keywords:
      'school summer storage, summer storage for students, store school items for summer, affordable school storage, campus storage solutions, summer student storage'
  },

  ['summer_storage_for_college_students']: {
    title: 'Summer Storage For College Students Secure And Easy',
    description:
      'Summer storage for college students made easy. Affordable, secure solutions to store your belongings during summer vacation.',
    keywords:
      'summer storage for college students, store items for summer break, affordable college summer storage, student storage solutions, summer campus storage'
  },

  ['commercial_storage_near_me']: {
    title: 'Find Reliable Commercial Storage Services Near Me',
    description:
      'Find reliable commercial storage services near me. Fast, secure, and affordable storage options for all your business storage needs.',
    keywords:
      'commercial storage near me, business storage solutions, nearby commercial storage units, affordable business storage, local commercial storage, commercial self-storage'
  },

  ['affordable_storage_rates']: {
    title: 'Affordable Storage Rates For All Your Storage Needs',
    description:
      'Affordable storage rates for all your storage needs. Fast, reliable, and secure storage solutions at great prices.',
    keywords:
      'affordable storage rates, cheap storage prices, low-cost storage units, budget-friendly storage services, discounted storage rates, storage deals'
  },

  ['free_storage_places_near_me']: {
    title: 'Free Storage Places Near Me Secure And Convenient',
    description:
      'Find free storage places near me. Secure, convenient, and affordable solutions for storing your personal belongings safely.',
    keywords:
      'free storage places near me, no-cost storage units, free storage near me, free self-storage options, nearby free storage solutions, free storage spaces'
  },

  ['ship_from_storage_services']: {
    title: 'Fast Ship From Storage Services Near You Available',
    description:
      'Ship from storage services available near you. Fast, secure, and affordable solutions for shipping your items from storage.',
    keywords:
      'ship from storage, ship stored items, storage shipping services, storage-to-door shipping, shipping from storage facility, affordable storage shipping services'
  },

  ['temporary_storage_solutions']: {
    title: 'Temporary Storage Solutions For Short-Term Needs',
    description:
      'Temporary storage solutions for short-term needs. Fast, secure, and affordable storage services for your temporary items.',
    keywords:
      'temporary storage solutions, short-term storage options,  temporary self-storage,self storage units near me, self storage units near me cheap, self storage units near me prices, self storage units prices'
  },

  ['personal_storage_solutions']: {
    title: 'Personal Storage Solutions Secure And Affordable',
    description:
      'Personal storage solutions available now. Affordable, secure, and convenient options for storing your personal belongings.',
    keywords:
      'personal storage solutions, private storage rental, personal self-storage, affordable storage for individuals, local storage solutions, temporary personal storage'
  },

  ['pickup_and_store_services']: {
    title: 'Pickup And Store Services Fast And Reliable',
    description:
      'Pickup and store services available now. Fast, affordable, and reliable solutions for picking up and storing your items.',
    keywords:
      'pickup and store services, storage pickup solutions, convenient storage services, pickup service, pickup and delivery services near me'
  },

  ['affordable_student_storage_near_me']: {
    title: 'Affordable Student Storage Services Near Me',
    description:
      'Affordable student storage near me services available. Secure, fast, and reliable options for storing student belongings safely.',
    keywords:
      'affordable student storage, cheap student storage, budget-friendly student storage, low-cost college storage, discount student storage, student storage rental'
  },

  ['golf_bags_storages_services_near_me']: {
    title: 'Golf Bags Storage Services Near Me Fast And Secure',
    description:
      'Golf bags storage services near me available now. Fast, secure, and affordable storage solutions for your golf equipment.',
    keywords:
      'golf bag storage, store golf clubs, golf gear storage solutions, affordable golf bag storage, local golf bag storage, golf equipment storage'
  },

  ['ski_equipment_and_gear_storages']: {
    title: 'Ski Equipment And Gear Storage Services Fast And Safe',
    description:
      'Ski equipment and gear storage services available. Fast, secure, and affordable solutions for storing your ski equipment during the offseason.',
    keywords:
      'ski equipment storage,  ski gear storage solutions,  ski storage near me,ski storage garage, ski equipment store near me, ski storage vail, ski storage solutions'
  },

  ['christmas_item_storage_near_me']: {
    title: 'Christmas Item Storage Near Me Secure And Convenient',
    description:
      'Christmas item storage services near me. Secure, fast, and convenient options to store your Christmas decorations safely during the year.',
    keywords:
      'Christmas item storage, store holiday items, Christmas decoration storage, seasonal item storage, affordable Christmas storage, holiday decor storage solutions'
  },

  ['storage_shipping_services_at_universities']: {
    title: 'University Storage And Shipping Services Reliable And Fast',
    description:
      'Reliable storage and shipping services at universities. Fast, secure, and affordable solutions for storing and shipping student belongings.',
    keywords:
      'storage shipping services at universities, student storage and shipping, affordable campus storage, college storage and shipping, university storage solutions'
  },

  ['dorm_room_storage_services']: {
    title: 'Dorm Room Storage Services Fast And Secure',
    description:
      'Dorm room storage services available. Fast, secure, and affordable options for storing your dorm room items during breaks or between semesters.',
    keywords:
      'dorm room storage, student storage solutions, store dorm room items, affordable student storage, college dorm storage, dorm room moving services'
  },

  ['office_equipment_storage_services']: {
    title: 'Office Equipment Storage Services Affordable And Secure',
    description:
      'Office equipment storage services available now. Secure, affordable, and reliable solutions for storing your office equipment safely.',
    keywords:
      'office equipment storage, store office equipment, secure office storage, business equipment storage, affordable office storage, office equipment rental storage'
  },

  ['moving_and_storage_services']: {
    title: 'Affordable Moving And Storage Services Available Now',
    description:
      'Affordable moving and storage services available now. Fast, secure, and reliable options for storing and moving your belongings.',
    keywords:
      'moving and storage services, moving and storage solutions, affordable moving storage, moving and storage deals, moving and storage companies, house moving storage'
  },

  ['luggage_shipping_services']: {
    title: 'Luggage Shipping Services Fast And Affordable',
    description:
      'Luggage shipping services available. Fast, affordable, and secure options for shipping your luggage safely to your destination.',
    keywords:
      'luggage shipping services, ship luggage, international luggage shipping, affordable luggage delivery, luggage shipping companies, fast luggage delivery'
  },

  ['moving_boxes_shipping_services']: {
    title: 'Moving Boxes Shipping Services Reliable And Fast',
    description:
      'Moving boxes shipping services available. Fast, secure, and reliable solutions for shipping your moving boxes to your new location.',
    keywords:
      'moving boxes shipping, ship moving boxes, moving box delivery, affordable box shipping, international box shipping, moving box services'
  },

  ['international_luggage_shipping']: {
    title: 'International Luggage Shipping Services Secure And Fast',
    description:
      'International luggage shipping services available now. Fast, secure, and affordable options for shipping your luggage internationally.',
    keywords:
      'international luggage shipping, ship luggage internationally, international baggage shipping, away luggage international shipping, international luggage service'
  },

  ['dhl_luggage_shipping']: {
    title: 'DHL Luggage Shipping Services Secure And Affordable',
    description:
      'DHL luggage shipping services available now. Affordable, secure, and fast solutions for shipping your luggage safely with DHL.',
    keywords:
      'DHL luggage shipping, luggage shipping with DHL, DHL international luggage shipping, affordable DHL luggage shipping, ship luggage with DHL'
  },

  ['fedex_luggage_shipping']: {
    title: 'FedEx Luggage Shipping Services Fast And Reliable',
    description:
      'FedEx luggage shipping services available. Fast, secure, and reliable options for shipping your luggage with FedEx to your destination.',
    keywords:
      'FedEx luggage shipping, luggage shipping with FedEx, FedEx international luggage shipping, affordable FedEx luggage shipping, ship luggage with FedEx'
  },

  ['ups_luggage_shipping']: {
    title: 'UPS Luggage Shipping Services Affordable And Fast',
    description:
      'UPS luggage shipping services available now. Fast, affordable, and secure options for shipping your luggage with UPS.',
    keywords:
      'UPS luggage shipping, luggage shipping with UPS, UPS international luggage shipping, affordable UPS luggage shipping, ship luggage with UPS'
  },

  ['storage_and_shipping_companies']: {
    title: 'Reliable Storage And Shipping Companies Near You',
    description:
      'Reliable storage and shipping companies near you. Fast, secure, and affordable solutions for storing and shipping your belongings.',
    keywords:
      'storage and shipping companies, affordable storage and shipping, international storage and shipping, global shipping and storage, storage and delivery services'
  },

  ['storage_and_international_shipping']: {
    title: 'Storage And International Shipping Solutions Secure',
    description:
      'Storage and international shipping services available. Secure, fast, and affordable options for storing and shipping your belongings internationally.',
    keywords:
      'storage and international shipping, ship and store internationally, global shipping and storage, international storage solutions, affordable international shipping'
  },

  ['ship_luggage_internationally']: {
    title: 'Ship Luggage Internationally Fast And Affordable',
    description:
      'Ship luggage internationally fast and affordably. Secure and reliable solutions for shipping your luggage to destinations worldwide.',
    keywords:
      'ship luggage internationally, global luggage shipping, international luggage delivery, affordable luggage shipping, worldwide luggage services, luggage shipping solutions'
  },

  ['cheapest_way_to_ship_luggage']: {
    title: 'Cheapest Way To Ship Luggage Fast And Secure',
    description:
      'The cheapest way to ship luggage fast and securely. Affordable and reliable solutions for shipping your luggage to any destination.',
    keywords:
      'cheapest way to ship luggage, affordable luggage shipping, low-cost luggage delivery, budget-friendly luggage shipping, cheap luggage shipping services'
  },

  ['luggage_delivery_services']: {
    title: 'Luggage Delivery Services Affordable And Fast',
    description:
      'Luggage delivery services available now. Fast, affordable, and secure options for delivering your luggage to your destination safely.',
    keywords:
      'luggage delivery services, ship luggage, international luggage delivery, fast luggage delivery, affordable luggage shipping, global luggage delivery services'
  },

  ['luggage_shipping_companies']: {
    title: 'Reliable Luggage Shipping Companies Available Now',
    description:
      'Reliable luggage shipping companies available now. Secure, fast, and affordable services for shipping your luggage safely.',
    keywords:
      'luggage shipping companies, best luggage shipping companies, top luggage delivery services, affordable luggage shipping, global luggage shipping, luggage shipping solutions'
  },

  ['luggage_storage_for_business_travelers']: {
    title: 'Luggage Storage For Business Travelers Secure And Convenient',
    description:
      'Luggage storage for business travelers. Fast, secure, and convenient options for storing your luggage while traveling for business.',
    keywords:
      'luggage storage for business travelers, store luggage for trips, business travel luggage storage, affordable travel storage, luggage storage solutions, corporate luggage'
  },

  ['residential_storage_and_shipping_solutions']: {
    title: 'Residential Storage And Shipping Solutions Fast And Affordable',
    description:
      'Residential storage and shipping solutions available now. Fast, affordable, and secure services for storing and shipping your belongings.',
    keywords:
      'residential storage solutions, home storage and shipping, affordable household storage, residential moving storage, store and ship home items'
  },

  ['international_luggage_storage_and_shipping']: {
    title: 'International Luggage Storage And Shipping Services',
    description:
      'International luggage storage and shipping services available. Fast, secure, and affordable options for storing and shipping luggage globally.',
    keywords:
      'international luggage storage, global luggage shipping, international travel storage, affordable luggage shipping, worldwide luggage storage'
  },

  ['ship_luggage_to_storage_facility']: {
    title: 'Ship Luggage To Storage Facility Fast And Secure',
    description:
      'Ship luggage to storage facility fast and securely. Affordable and reliable services for storing your luggage safely in a storage facility.',
    keywords:
      'ship luggage to storage, luggage storage facility, store luggage for travel, affordable luggage storage and shipping, ship luggage to storage unit'
  },

  ['affordable_college_storage_solutions']: {
    title: 'Affordable College Storage Solutions For Students',
    description:
      'Affordable college storage solutions for students. Fast, secure, and affordable options for storing college belongings during the year.',
    keywords:
      'affordable college storage, student storage solutions, cheap college storage, dorm room storage, college moving and storage, budget-friendly student storage'
  },

  ['vacation_luggage_storage_and_shipping']: {
    title: 'Vacation Luggage Storage And Shipping Solutions',
    description:
      'Vacation luggage storage and shipping solutions. Fast, secure, and affordable options for storing and shipping luggage during vacations.',
    keywords:
      'vacation luggage storage, travel luggage storage solutions, affordable vacation storage, store luggage for travel, seasonal travel luggage storage'
  },

  ['seasonal_luggage_storage_solutions']: {
    title: 'Seasonal Luggage Storage Solutions Affordable And Secure',
    description:
      'Seasonal luggage storage solutions available now. Fast, secure, and affordable services for storing your luggage during the off-season.',
    keywords:
      'seasonal luggage storage, store luggage seasonally, affordable seasonal storage, short-term luggage storage, long-term seasonal luggage storage'
  },

  ['shipping_for_college_students']: {
    title: 'Affordable Shipping for College Students',
    description:
      'Discover the best shipping options for college students! Save time and money with our essential tips and services tailored for academic life.',
    keywords:
      'College student shipping, Student shipping tips, Affordable shipping options, Campus delivery services, International student shipping, Shipping resources for students, Packing tips for college students'
  }
})
